import React from "react";
import "./ServicePages.scss";

//Panels
import Hero from "./Components/Hero";

//Images
import firefeatures from "./images/firefeatures/bg-firefeatures.jpg";
import featureA1 from "./images/firefeatures/feature-a-1.jpg";
import featureA2 from "./images/firefeatures/feature-a-2.jpg";
import featureA3 from "./images/firefeatures/feature-a-3.jpg";
// import featureB1 from "./images/patios/feature-b-1.jpg";
// import featureB2 from "./images/patios/feature-b-2.jpg";
// import featureB3 from "./images/patios/feature-b-3.jpg";
// import featureC1 from "./images/patios/feature-c-1.jpg";
// import featureC2 from "./images/patios/feature-c-2.jpg";
// import featureC3 from "./images/patios/feature-c-3.jpg";

const FireFeatures = () => {
  return (
    <div className="container-fluid page-featured">
      <Hero title={"FireFeatures"} background={firefeatures} />
      <div className="row justify-content-center">
        <div className="col-11 col-md-9">
          <div className="row justify-content-center panel-content">
            <div className="col-12">
              <h2 className="text-center text-uppercase mb-4">Title Here</h2>
              <p>Awaiting Content</p>
            </div>
            <div className="col-12 mt-5">
              <div className="row justify-content-center">
                <div className="col-12 col-md-8 col-lg-4">
                  <img className="mb-2 mb-lg-0" src={featureA1} alt="Featured" />
                </div>
                <div className="col-12 col-md-8 col-lg-4">
                  <img className="mb-2 mb-lg-0" src={featureA2} alt="Featured" />
                </div>
                <div className="col-12 col-md-8 col-lg-4">
                  <img className="mb-2 mb-lg-0" src={featureA3} alt="Featured" />
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center panel-content">
            <div className="col-12">
              <h2 className="text-center text-uppercase mb-4">Title</h2>
              <p>Awaiting Content</p>
            </div>
            <div className="col-12 mt-5">
              <div className="row justify-content-center">
                <div className="col-12 col-md-8 col-lg-4">
                  <div className="image-style">
                    <img className="mb-2 mb-lg-0" src={featureA1} alt="Featured" />
                    <div className="text">
                      <p>
                        Angelus Tubled Estate
                        <br />
                        Cobble I &amp; II in Terracotta
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-8 col-lg-4">
                  <div className="image-style">
                    <img className="mb-2 mb-lg-0" src={featureA2} alt="Featured" />
                    <div className="text">
                      <p>
                        Angelus Tubled Estate
                        <br />
                        Cobble I &amp; II in Terracotta
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-8 col-lg-4">
                  <div className="image-style">
                    <img className="mb-2 mb-lg-0" src={featureA3} alt="Featured" />
                    <div className="text">
                      <p>
                        Angelus Tubled Estate
                        <br />
                        Cobble I &amp; II in Terracotta
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FireFeatures;
